import { OpenRequest } from "../types";

export const useHost = () => ({
  close: () => {
    // eslint-disable-next-line no-alert
    alert("Closing browser component");
  },
  selectTab: (tab: number) => {
    // eslint-disable-next-line no-alert
    alert(`Selecting tab ${tab}`);
  },
  interceptClose: (
    callback: (continueClose: (shouldClose: boolean) => void) => void,
  ) => {
    callback((shouldClose) => {
      // eslint-disable-next-line no-alert
      alert(`Closing browser component: ${shouldClose}`);
    });
  },
  version: {
    major: 0,
    minor: 0,
    build: 0,
    revision: 0,
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isEarlierThanVersion: ({ major, minor }: { major: number; minor: number }) =>
    false,
  open: (options: OpenRequest) => {
    // eslint-disable-next-line no-alert
    alert(
      `Opening new browser component with url: ${options.url}, title: ${options.title}`,
    );
  },
  navigate: (
    options:
      | {
          target: "intake-form-builder";
          formId?: string;
          reminderMessage?: "custom" | "default";
        }
      | { target: "intake-settings"; tab?: string }
      | {
          target: "matter-intake-tab";
          matterId: string;
          submissionId: string;
        }
      | { target: "matter-details"; matterId: string },
  ) => {
    const mapping: Record<string, string> = {
      "intake-form-builder": "builder",
      "intake-settings": "settings",
      "matter-intake-tab": "tab",
    };
    // eslint-disable-next-line no-alert
    alert(`Navigating to ${options.target}`);
    // no local matter page
    if (options.target === "matter-details") return;
    const { formId } = options as { formId?: string };
    const { tab } = options as { tab?: string };
    const { reminderMessage } = options as { reminderMessage?: string };
    const parts = window.location.pathname.split("/");
    const base = `${parts.slice(0, -1).join("/")}/${mapping[options.target]}`;
    if (options.target === "intake-form-builder" && formId) {
      window.location.href = `${base}/${formId}`;
    } else if (options.target === "intake-form-builder" && reminderMessage) {
      window.location.href = `${base}?reminderMessage=${reminderMessage}`;
    } else if (options.target === "intake-settings" && tab) {
      window.location.href = `${base}?tab=${tab}`;
    } else {
      window.location.href = base;
    }
  },
});
